module.exports = {"150223102":"满都拉镇","150223103":"希拉穆仁镇","150223104":"百灵庙镇","150223105":"石宝镇","150223106":"乌克忽洞镇","150223107":"明安镇","150223108":"巴音花镇","150223213":"达尔汗苏木","150223214":"查干哈达苏木","150223215":"巴音敖包苏木","150223216":"西河乡","150223217":"小文公乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150223.json
// module id = 498
// module chunks = 0